import React from 'react';
import { LoadingState } from './LoadingState';
import { EmptyState } from './EmptyState';
import { ErrorState } from './ErrorState';

/**
 * Три разных состояния списка вместо одного «Нет записей».
 *
 * Раньше пустое состояние показывалось и пока данные грузятся, и когда запрос
 * упал (catch {} глушил ошибку): «Нет пользователей» при 9 пользователях,
 * «Нет записей» при 600 тыс. кодов. Порядок проверки:
 *   1) ошибка — текст ошибки и «Повторить»;
 *   2) загрузка без данных — спиннер «Загрузка…»;
 *   3) пусто — только после успешного пустого ответа;
 *   4) иначе — содержимое (children).
 * Если данные уже есть и идёт обновление, показываем данные, не спиннер.
 */
export function LoadState({
  loading = false,
  error = null,
  empty = false,
  onRetry,
  loadingText = 'Загрузка…',
  emptyIcon,
  emptyTitle = 'Нет записей',
  emptyDescription,
  emptyAction,
  compact = false,
  children,
}) {
  if (error) {
    const msg = typeof error === 'string' ? error : (error?.message || 'Не удалось загрузить данные');
    return <ErrorState message={`Не удалось загрузить: ${msg}`} onRetry={onRetry} compact={compact} />;
  }
  if (loading && empty) {
    return <LoadingState text={loadingText} compact={compact} />;
  }
  if (empty) {
    return (
      <EmptyState icon={emptyIcon} title={emptyTitle} description={emptyDescription}
                  action={emptyAction} compact={compact} />
    );
  }
  return <>{children}</>;
}
